import axios from "./axios";
import { User } from "../types/User";

export const getUserAndBooks = async (user: User) => {
  const response = await axios.get("/web/getRecommendBooks", { params: user });
  window.sessionStorage.setItem("library", JSON.stringify(user.manage_code));
  return response.data;
};
